import { WSTable } from "@wingspanhq/fe-component-library";
import { Worksite } from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";

import { getColumns } from "./columns";

export type WorksiteTableItem = {
  worksite: Worksite;
  /** Names of the engagements assigned to this work site. */
  engagementNames: string[];
};

type Props = {
  items: WorksiteTableItem[];
  loading?: boolean;
  onEdit: (item: WorksiteTableItem) => void;
  onDelete: (item: WorksiteTableItem) => void;
};

export const TableWorksites: React.FC<Props> = props => {
  const tableData = useMemo(
    () =>
      props.items.map(item => ({
        id: item.worksite.id as string,
        data: item
      })),
    [props.items]
  );
  const columns = useMemo(() => getColumns(), []);

  return (
    <WSTable<WorksiteTableItem>
      loading={props.loading}
      showHeader
      columns={columns}
      tableData={tableData}
      rowMenuActions={rowItem => [
        {
          icon: "edit",
          label: "Edit work site",
          onClick: () => props.onEdit(rowItem.data)
        },
        {
          icon: "trash",
          label: "Delete work site",
          onClick: () => props.onDelete(rowItem.data)
        }
      ]}
    />
  );
};
